(function($) {
    $(document).ready(function() {

        if ($(".gallery-slider").length > 0) {
            $('.gallery-slider .slider-outer').on('init', function(event, slick) {
                $('.gallery-slider .navigation .next, .gallery-slider .navigation .prev').on('click', function() {
                    $('.gallery-slider .slider-outer').slick('slickPause');
                    setTimeout(function() {
                        $('.gallery-slider .slider-outer').slick('slickPlay');
                    }, 2000);
                });

            });

            numSlick = 0;
            $('.gallery-slider .slider-outer').each(function() {
                numSlick++;
                $(this).parent().addClass('slider-' + numSlick);
                $(this).slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    speed: 2300,
                    cssEase: 'linear',
                    variableWidth: true,
                    accessibility: true,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slideToScroll: 1,
                            variableWidth: false
                        }
                    }]
                });
            });

            $('.slider-1 .next').click(function() {
                $('.slider-1 .slider-outer').slick('slickNext');
            });
            $('.slider-1 .prev').click(function() {
                $('.slider-1 .slider-outer').slick('slickPrev');
            });

            $('.slider-2 .next').click(function() {
                $('.slider-2 .slider-outer').slick('slickNext');
            });
            $('.slider-2 .prev').click(function() {
                $('.slider-2 .slider-outer').slick('slickPrev');
            });

            $('.slider-3 .next').click(function() {
                $('.slider-3 .slider-outer').slick('slickNext');
            });
            $('.slider-3 .prev').click(function() {
                $('.slider-3 .slider-outer').slick('slickPrev');
            });

            $('.slider-4 .next').click(function() {
                $('.slider-4 .slider-outer').slick('slickNext');
            });
            $('.slider-4 .prev').click(function() {
                $('.slider-4 .slider-outer').slick('slickPrev');
            });

            $(".gallery-slider").css("opacity", "1");
            // $('.gallery-slider .col-three a').on('click', function(e) {
            //     e.preventDefault();
            // });


        }
    });
    $(window).on('load resize', function() {
        if ($(window).width() < 1025) {
            $('.gallery-slider .text-wrap').matchHeight();
        }
    })
})(jQuery);